// extracted by mini-css-extract-plugin
module.exports = {"base":"_6XshOA","active":"_1yPKKF","failed":"_31KIE3","succeeded":"kr5NKT","text":"_3IYlU_","spinning":"_1V0Juk","spinner":"hkTmLx"};